import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventDotInput]',
})
export class PreventDotInputDirective {
  constructor() {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === '.') {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData;
    const pastedData = clipboardData?.getData('text') || '';

    if (pastedData.includes('.')) {
      event.preventDefault();
    }
  }
}
